enum Category {
  Sleep = "Sleep",
  Daily = "Daily"
}

export default Category;
